import { render } from "./IconArrowBack.vue?vue&type=template&id=4d494e16"
import script from "./IconArrowBack.vue?vue&type=script&lang=ts"
export * from "./IconArrowBack.vue?vue&type=script&lang=ts"
script.render = render

export default script